import { render, staticRenderFns } from "./CmgBanner.vue?vue&type=template&id=375716d4&scoped=true&lang=pug"
import script from "./cmg-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBanner.vue?vue&type=style&index=0&id=375716d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375716d4",
  null
  
)

export default component.exports